// src/constants/colors.js
export const lightColors = {
  // App Theme - Inspired by Haitian Flag Colors
  primary: '#D42E1E',
  primaryLight: '#E85444',
  primaryDark: '#B82214',
  secondary: '#0072B0',
  secondaryLight: '#2B8EC9',
  secondaryDark: '#005A8C',
  
  // Accent Colors
  accentGold: '#F5C624',
  accentGreen: '#1A8C4A',
  
  // Status
  success: '#1A8C4A',
  error: '#D42E1E',
  warning: '#F5C624',
  info: '#0072B0',
  
  // Neutrals
  white: '#FFFFFF',
  black: '#000000',
  gray50: '#F8F7F4',
  gray100: '#F0EFEB',
  gray200: '#E0DED8',
  gray300: '#C5C2B9',
  gray400: '#A6A299',
  gray500: '#878177',
  gray600: '#6B665C',
  gray700: '#4F4A42',
  gray800: '#332F29',
  gray900: '#1A1814',
  
  // Backgrounds
  background: '#FAF9F7',
  surface: '#F8F7F4',
  cardBackground: '#FFFFFF',
  
  // Text
  textPrimary: '#1A1814',
  textSecondary: '#6B665C',
  textTertiary: '#A6A299',
  
  // Status indicators
  online: '#1A8C4A',
  offline: '#A6A299',
  
  // Cultural Accents
  tropicalGreen: '#2D8B4E',
  oceanBlue: '#0088B8',
  sunsetOrange: '#E8763A',
  coffeeBrown: '#6B4F3A',
};

export const darkColors = {
  primary: '#E85444',
  primaryLight: '#F06E5E',
  primaryDark: '#C42516',
  secondary: '#2B8EC9',
  secondaryLight: '#4BA8D8',
  secondaryDark: '#006699',
  accentGold: '#F5C624',
  accentGreen: '#2D8B4E',
  success: '#2D8B4E',
  error: '#E85444',
  warning: '#F5C624',
  info: '#2B8EC9',
  white: '#1A1814',
  black: '#FAF9F7',
  gray50: '#1A1814',
  gray100: '#332F29',
  gray200: '#4F4A42',
  gray300: '#6B665C',
  gray400: '#878177',
  gray500: '#A6A299',
  gray600: '#C5C2B9',
  gray700: '#E0DED8',
  gray800: '#F0EFEB',
  gray900: '#F8F7F4',
  background: '#1A1814',
  surface: '#332F29',
  cardBackground: '#2A2620',
  textPrimary: '#F8F7F4',
  textSecondary: '#C5C2B9',
  textTertiary: '#878177',
  online: '#2D8B4E',
  offline: '#878177',
  tropicalGreen: '#3BA364',
  oceanBlue: '#33A8D4',
  sunsetOrange: '#F08A54',
  coffeeBrown: '#8B6F5A',
};

const colors = lightColors;
export default colors;